import { APPOINTMENT_SELF_SERVICE_URL, buildUrl, CSS_MY_JOBS_URL, CSS_PAGE_URL } from "../../../config/urls";
import { Stage } from "../../../helpers/get-settings";

type UseUrlBuilderParamsType = (
  requisitionId: string,
  applicationId: string,
  stage: Stage | undefined
) => {
  cssURLSchedule: string;
  appointmentURLService: string;
  dashboardURL: string;
};

export const useUrlBuilder: UseUrlBuilderParamsType = (requisitionId, applicationId, stage) => {
  const cssURLSchedule = buildUrl(CSS_PAGE_URL, {
    stage,
    requisitionId,
    applicationId,
  });
  const appointmentURLService = buildUrl(APPOINTMENT_SELF_SERVICE_URL, {
    stage,
    requisitionId,
    applicationId,
  });
  const dashboardURL = buildUrl(CSS_MY_JOBS_URL, {
    stage,
  });

  return { cssURLSchedule, appointmentURLService, dashboardURL };
};
